import localForage from 'localforage';
import { Dispatch } from 'redux';
import StorageContants from '../../config/storage.constants';
import { LocalStorage } from '../../customer-call-sdk';
import * as AuthAPI from '../../services/auth.service';
import { User } from '../../types';
import {
    SET_USER,
    GET_SESSION_SUCCESS,
    GET_SESSION_ERROR,
    GET_SESSION,
    GetSessionSuccessAction,
    GetSessionErrorAction,
    LOGOUT,
    SetUserAction,
    LogoutAction,
} from './types';
/**
 * Set user action
 * @param {User} User the logged in user
 *
 */
export function setUser(user: User) {
    return async (dispatch: Dispatch<SetUserAction>) => {
        LocalStorage.set(StorageContants.USER_DETAIL, JSON.stringify(user));
        dispatch({
            type: SET_USER,
            payload: { user },
        });
    };
}
/**
 * Get session success action
 *
 * @param {User} user the logged in user
 * @returns {GetSessionSuccessAction}
 */
function getSessionSuccess(user: User): GetSessionSuccessAction {
    return {
        type: GET_SESSION_SUCCESS,
        payload: {
            user,
        },
    };
}
/**
 * Get session error action
 * @param {any} error error object
 *
 * @return {GetSessionErrorAction}
 */
function getSessionError(error: any): GetSessionErrorAction {
    return {
        type: GET_SESSION_ERROR,
        payload: {
            error,
        },
    };
}
/**
 * Get session action
 */
export function getSession() {
    return async (dispatch: any) => {
        dispatch({ type: GET_SESSION });
        const { data, error } = await AuthAPI.getUser();
        if (data?.user) {
            dispatch(getSessionSuccess(data.user));
        }
        if (error) {
            dispatch(getSessionError(error));
        }
    };
}
/**
 * Logout action
 */
export const logout = () => async (dispatch: Dispatch<LogoutAction>) => {
    LocalStorage.removeList(Object.values(StorageContants));
    dispatch({
        type: LOGOUT,
    });
};

/**
 * Save user in indexdeddb
 * @param {User} user loggedin user detail
 * @param {Partial<User>} value
 */
export async function saveUserInStorage(user: User, value: Partial<User>) {
    await localForage.setItem('user', {
        ...user,
        ...value,
    });
}
